import React from 'react';

const ICON_COLOR = '#b0bec5';

const icons = {
  clear: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="12" cy="12" r="5" fill="#f9a825" />
      <g stroke="#f9a825" strokeWidth="2" strokeLinecap="round">
        <line x1="12" y1="1" x2="12" y2="4" />
        <line x1="12" y1="20" x2="12" y2="23" />
        <line x1="1" y1="12" x2="4" y2="12" />
        <line x1="20" y1="12" x2="23" y2="12" />
        <line x1="4.2" y1="4.2" x2="6.3" y2="6.3" />
        <line x1="17.7" y1="17.7" x2="19.8" y2="19.8" />
        <line x1="4.2" y1="19.8" x2="6.3" y2="17.7" />
        <line x1="17.7" y1="6.3" x2="19.8" y2="4.2" />
      </g>
    </svg>
  ),
  partly_cloudy: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <circle cx="10" cy="8" r="4" fill="#f9a825" />
      <g stroke="#f9a825" strokeWidth="1.5" strokeLinecap="round">
        <line x1="10" y1="1" x2="10" y2="3" />
        <line x1="3" y1="8" x2="5" y2="8" />
        <line x1="4.3" y1="3.3" x2="5.7" y2="4.7" />
      </g>
      <path d="M8 18h10a4 4 0 000-8 4.5 4.5 0 00-8.5 1A3 3 0 008 18z" fill={ICON_COLOR} />
    </svg>
  ),
  fog: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none" stroke={ICON_COLOR} strokeWidth="2" strokeLinecap="round">
      <line x1="3" y1="8" x2="21" y2="8" />
      <line x1="5" y1="12" x2="19" y2="12" />
      <line x1="3" y1="16" x2="21" y2="16" />
      <line x1="7" y1="20" x2="17" y2="20" />
    </svg>
  ),
  drizzle: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 16h12a5 5 0 000-10 5.5 5.5 0 00-10.5 1A4 4 0 006 16z" fill={ICON_COLOR} />
      <g stroke="#64b5f6" strokeWidth="1.5" strokeLinecap="round">
        <line x1="8" y1="18" x2="8" y2="20" />
        <line x1="12" y1="18" x2="12" y2="20" />
        <line x1="16" y1="18" x2="16" y2="20" />
      </g>
    </svg>
  ),
  rain: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 14h12a5 5 0 000-10 5.5 5.5 0 00-10.5 1A4 4 0 006 14z" fill={ICON_COLOR} />
      <g stroke="#42a5f5" strokeWidth="2" strokeLinecap="round">
        <line x1="7" y1="16" x2="6" y2="20" />
        <line x1="11" y1="16" x2="10" y2="22" />
        <line x1="15" y1="16" x2="14" y2="20" />
        <line x1="19" y1="16" x2="18" y2="19" />
      </g>
    </svg>
  ),
  showers: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 14h12a5 5 0 000-10 5.5 5.5 0 00-10.5 1A4 4 0 006 14z" fill={ICON_COLOR} />
      <g stroke="#42a5f5" strokeWidth="2" strokeLinecap="round">
        <line x1="7" y1="16" x2="6" y2="20" />
        <line x1="11" y1="16" x2="10" y2="22" />
        <line x1="15" y1="16" x2="14" y2="20" />
        <line x1="19" y1="16" x2="18" y2="19" />
      </g>
    </svg>
  ),
  snow: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 14h12a5 5 0 000-10 5.5 5.5 0 00-10.5 1A4 4 0 006 14z" fill={ICON_COLOR} />
      <g fill="#e0e0e0">
        <circle cx="8" cy="17" r="1.5" />
        <circle cx="13" cy="19" r="1.5" />
        <circle cx="17" cy="17" r="1.5" />
        <circle cx="10" cy="22" r="1.5" />
      </g>
    </svg>
  ),
  snow_showers: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 14h12a5 5 0 000-10 5.5 5.5 0 00-10.5 1A4 4 0 006 14z" fill={ICON_COLOR} />
      <g fill="#e0e0e0">
        <circle cx="8" cy="17" r="1.5" />
        <circle cx="13" cy="19" r="1.5" />
        <circle cx="17" cy="17" r="1.5" />
      </g>
    </svg>
  ),
  thunderstorm: (size) => (
    <svg width={size} height={size} viewBox="0 0 24 24" fill="none">
      <path d="M6 12h12a5 5 0 000-10 5.5 5.5 0 00-10.5 1A4 4 0 006 12z" fill={ICON_COLOR} />
      <polygon points="13,12 10,18 13,18 11,23 16,16 13,16 15,12" fill="#fdd835" />
    </svg>
  ),
};

export function WeatherIcon({ condition, size = 18 }) {
  const renderIcon = icons[condition] || icons.partly_cloudy;
  return <span style={{ display: 'inline-flex', verticalAlign: 'middle', flexShrink: 0 }}>{renderIcon(size)}</span>;
}

export function formatTemp(temp) {
  if (temp == null) return '';
  return `${Math.round(temp)}\u00B0F`;
}
